export default __webpack_public_path__ + "static/media/EnthalpyCoils.0f101cf8.svg";